<div class="header">
  <div class="header__container">
    @if (isProgressBarLoading()) {
      <div class="header__loading-bar-container">
        <mat-progress-bar
          class="header__loading-bar"
          mode="indeterminate"
          color="primary"
        />
      </div>
    }
    <div class="header__menu-toggle">
      <img
        data-auto-id="toggleSideNavBarClick"
        class="header__menu-toggle-image"
        [src]="menuImage"
        (click)="toggleSideNavBar($event)"
        alt="toggle menu icon"
      />
    </div>
    <div class="header__logo-container">
      <a [routerLink]="PAGE_URLS.QUICK_ACCESS">
        <img
          class="header__logo"
          src="assets/logos/blu-logo.png"
          alt="blu-logo icon"
        />
      </a>
    </div>
    <div
      data-auto-id="showModuleSearchClick"
      class="header__search-container"
      (click)="showModuleSearch($event)"
    >
      <img
        class="header__search-image"
        src="assets/icons/svg/colored/search-blue.svg"
        alt="user"
      />
      <div class="header__search-label">Search for Modules</div>
    </div>
    @if (getIsModuleSearchVisible()) {
      <form class="header__search-control">
        <app-search-modules (closeClicked)="setIsModuleSearchVisible(false)" />
      </form>
    }
    <div class="header__user-information">
      <div
        data-auto-id="changeColorModeClick"
        [matTooltip]="switchColorModeMessage"
        class="header__mode"
        (click)="changeColorMode()"
      >
        <img
          class="header__mode-image"
          [src]="colorModeImage"
          alt="switch color mode icon"
        />
      </div>
      <div
        class="header__user-notifications"
        [class.header__user-notifications_has-notifications]="
          hasUnreadPopupNotifications
        "
      >
        <img
          data-auto-id="toggleNotificationsClick"
          class="header__user-notifications-image"
          [src]="notificationsImage"
          (click)="toggleNotifications($event)"
          alt=""
        />
        <div
          class="header__notifications"
          [class.header__notifications_is-visible]="isNotificationsVisible"
        >
          <app-popup-notifications (closed)="isNotificationsVisible = false" />
        </div>
      </div>
      <div class="header__user-profile-picture-container">
        <img
          class="header__user-profile-picture"
          [src]="getAdminProfilePicture()"
          alt="user"
        />
      </div>
    </div>
  </div>
</div>
